export interface Contract {
  id: string;
  name: string;
  category: string;
  description: string;
  price: {
    min: number;
    max: number;
  };
  processingTime: string;
  keyPoints: string[];
  useCases: string[];
  relatedDocuments: string[];
}

export const contractCategories = [
  { id: 'general', name: 'Algemene contracten' },
  { id: 'commercial', name: 'Commerciële contracten' },
  { id: 'employment', name: 'Arbeidsovereenkomsten' },
  { id: 'intellectual', name: 'Intellectueel eigendom' },
  { id: 'gdpr', name: 'RGPD en gegevensbescherming' },
  { id: 'corporate', name: 'Vennootschapsrecht' },
  { id: 'legal', name: 'Juridische documenten' },
  { id: 'compliance', name: 'Compliance' }
];

export const contracts: Contract[] = [
  {
    id: '1',
    name: 'Aandeelhoudersbesluit benoeming bestuurder',
    category: 'corporate',
    description: 'Besluit van aandeelhouders voor het benoemen van een nieuwe bestuurder.',
    price: {
      min: 150,
      max: 300
    },
    processingTime: '2-3 werkdagen',
    keyPoints: [
      'Benoeming bestuurder',
      'Bevoegdheden',
      'Ingangsdatum',
      'Voorwaarden'
    ],
    useCases: [
      'Nieuwe bestuurder benoemen',
      'Wijziging bestuur',
      'Corporate governance'
    ],
    relatedDocuments: [
      'Uittreksel KvK',
      'Statuten',
      'Bestuurdersovereenkomst'
    ]
  },
  {
    id: '2',
    name: 'Aandeelhoudersbesluit ontbinding vennootschap',
    category: 'corporate',
    description: 'Besluit tot ontbinding van de vennootschap door de aandeelhouders.',
    price: {
      min: 150,
      max: 300
    },
    processingTime: '2-3 werkdagen',
    keyPoints: [
      'Ontbindingsbesluit',
      'Vereffening',
      'Bewaarplicht',
      'Publicatie'
    ],
    useCases: [
      'Bedrijfsbeëindiging',
      'Herstructurering',
      'Liquidatie'
    ],
    relatedDocuments: [
      'Jaarrekening',
      'Vereffeningsplan',
      'Publicatie Staatscourant'
    ]
  },
  {
    id: '3',
    name: 'Aandeelhoudersbesluit ontbinding vennootschap Engels',
    category: 'corporate',
    description: 'Shareholders resolution for company dissolution.',
    price: {
      min: 200,
      max: 350
    },
    processingTime: '2-3 werkdagen',
    keyPoints: [
      'Dissolution decision',
      'Liquidation',
      'Record keeping',
      'Publication'
    ],
    useCases: [
      'Business termination',
      'Restructuring',
      'Liquidation'
    ],
    relatedDocuments: [
      'Annual accounts',
      'Liquidation plan',
      'Official publication'
    ]
  },
  {
    id: '4',
    name: 'Aandeelhoudersbesluit turboliquidatie',
    category: 'corporate',
    description: 'Besluit voor versnelde ontbinding van de vennootschap.',
    price: {
      min: 150,
      max: 300
    },
    processingTime: '2-3 werkdagen',
    keyPoints: [
      'Versnelde ontbinding',
      'Geen baten',
      'Directe beëindiging',
      'Publicatie'
    ],
    useCases: [
      'Snelle bedrijfsbeëindiging',
      'Lege vennootschap',
      'Kostenefficiënte ontbinding'
    ],
    relatedDocuments: [
      'Verklaring geen baten',
      'Uitschrijving KvK',
      'Publicatie'
    ]
  },
  {
    id: '5',
    name: 'Aandeelhoudersbesluit uitgifte aandelen',
    category: 'corporate',
    description: 'Besluit tot uitgifte van nieuwe aandelen.',
    price: {
      min: 150,
      max: 300
    },
    processingTime: '2-3 werkdagen',
    keyPoints: [
      'Aantal aandelen',
      'Uitgiftekoers',
      'Stemrecht',
      'Voorwaarden'
    ],
    useCases: [
      'Kapitaalverhoging',
      'Nieuwe investeerder',
      'Herstructurering'
    ],
    relatedDocuments: [
      'Statuten',
      'Aandeelhoudersregister',
      'Storting bewijs'
    ]
  },
  {
    id: '6',
    name: 'Aandeelhoudersbesluit uitgifte aandelen converteerbare lening',
    category: 'corporate',
    description: 'Besluit voor aandelenuitgifte bij conversie van lening.',
    price: {
      min: 150,
      max: 300
    },
    processingTime: '2-3 werkdagen',
    keyPoints: [
      'Conversievoorwaarden',
      'Aantal aandelen',
      'Uitgiftekoers',
      'Leningvoorwaarden'
    ],
    useCases: [
      'Conversie lening',
      'Investering',
      'Herstructurering'
    ],
    relatedDocuments: [
      'Leningovereenkomst',
      'Conversieberekening',
      'Aandeelhoudersregister'
    ]
  },
  {
    id: '7',
    name: 'Aandeelhoudersbesluit vaststelling jaarrekening',
    category: 'corporate',
    description: 'Besluit tot vaststelling van de jaarrekening.',
    price: {
      min: 150,
      max: 250
    },
    processingTime: '2-3 werkdagen',
    keyPoints: [
      'Vaststelling cijfers',
      'Resultaatbestemming',
      'Decharge bestuur',
      'Publicatie'
    ],
    useCases: [
      'Jaarafsluiting',
      'Wettelijke verplichting',
      'Verantwoording'
    ],
    relatedDocuments: [
      'Jaarrekening',
      'Accountantsverklaring',
      'Publicatiestukken'
    ]
  },
  {
    id: '8',
    name: 'Aandeelhoudersovereenkomst',
    category: 'corporate',
    description: 'Overeenkomst tussen aandeelhouders over hun onderlinge verhoudingen.',
    price: {
      min: 500,
      max: 1000
    },
    processingTime: '5-7 werkdagen',
    keyPoints: [
      'Stemrechten',
      'Dividendbeleid',
      'Exit regeling',
      'Geschillenregeling'
    ],
    useCases: [
      'Oprichting BV',
      'Nieuwe aandeelhouder',
      'Joint venture'
    ],
    relatedDocuments: [
      'Statuten',
      'Aandeelhoudersregister',
      'Business plan'
    ]
  },
  {
    id: '9',
    name: 'Aandeelhoudersovereenkomst Engels',
    category: 'corporate',
    description: 'Shareholders agreement governing mutual relationships.',
    price: {
      min: 600,
      max: 1200
    },
    processingTime: '5-7 werkdagen',
    keyPoints: [
      'Voting rights',
      'Dividend policy',
      'Exit arrangements',
      'Dispute resolution'
    ],
    useCases: [
      'Company formation',
      'New shareholder',
      'Joint venture'
    ],
    relatedDocuments: [
      'Articles of association',
      'Shareholders register',
      'Business plan'
    ]
  },
  {
    id: '10',
    name: 'Algemene volmacht',
    category: 'general',
    description: 'Algemene volmacht voor vertegenwoordiging.',
    price: {
      min: 100,
      max: 200
    },
    processingTime: '1-2 werkdagen',
    keyPoints: [
      'Bevoegdheden',
      'Duur',
      'Beperkingen',
      'Herroeping'
    ],
    useCases: [
      'Vertegenwoordiging',
      'Zaakwaarneming',
      'Procesvolmacht'
    ],
    relatedDocuments: [
      'Legitimatiebewijs',
      'KvK uittreksel',
      'Verklaring bevoegdheid'
    ]
  },
  {
    id: '11',
    name: 'Algemene Voorwaarden Coaching / HR (zzp)',
    category: 'commercial',
    description: 'Algemene voorwaarden voor coaching en HR dienstverlening.',
    price: {
      min: 300,
      max: 600
    },
    processingTime: '3-5 werkdagen',
    keyPoints: [
      'Dienstverlening',
      'Aansprakelijkheid',
      'Tarieven',
      'Annulering'
    ],
    useCases: [
      'Coaching praktijk',
      'HR advies',
      'Training'
    ],
    relatedDocuments: [
      'Opdrachtbevestiging',
      'Privacyverklaring',
      'Dienstbeschrijving'
    ]
  },
  {
    id: '12',
    name: 'Algemene Voorwaarden Creatief / Design (zzp)',
    category: 'commercial',
    description: 'Algemene voorwaarden voor creatieve en design diensten.',
    price: {
      min: 300,
      max: 600
    },
    processingTime: '3-5 werkdagen',
    keyPoints: [
      'Intellectueel eigendom',
      'Leveringsvoorwaarden',
      'Revisies',
      'Gebruik'
    ],
    useCases: [
      'Grafisch ontwerp',
      'Webdesign',
      'Fotografie'
    ],
    relatedDocuments: [
      'Prijslijst',
      'Portfolio licentie',
      'Projectvoorstel'
    ]
  },
  {
    id: '13',
    name: 'Algemene Voorwaarden ICT / Software Development (zzp)',
    category: 'commercial',
    description: 'Algemene voorwaarden voor ICT en software ontwikkeling.',
    price: {
      min: 300,
      max: 600
    },
    processingTime: '3-5 werkdagen',
    keyPoints: [
      'Software licentie',
      'Ontwikkeling',
      'Onderhoud',
      'Service levels'
    ],
    useCases: [
      'Software ontwikkeling',
      'IT consultancy',
      'Systeembeheer'
    ],
    relatedDocuments: [
      'SLA',
      'Functioneel ontwerp',
      'Acceptatiecriteria'
    ]
  },
  {
    id: '14',
    name: 'Algemene Voorwaarden Zakelijke Dienstverlening (zzp)',
    category: 'commercial',
    description: 'Algemene voorwaarden voor zakelijke dienstverlening.',
    price: {
      min: 300,
      max: 600
    },
    processingTime: '3-5 werkdagen',
    keyPoints: [
      'Diensten',
      'Tarieven',
      'Aansprakelijkheid',
      'Geheimhouding'
    ],
    useCases: [
      'Consultancy',
      'Advies',
      'Interim diensten'
    ],
    relatedDocuments: [
      'Offerte template',
      'Urenregistratie',
      'Factuurvoorbeeld'
    ]
  },
  {
    id: '15',
    name: 'Algemene Voorwaarden Management / Consultancy (zzp)',
    category: 'commercial',
    description: 'Algemene voorwaarden voor management en consultancy diensten.',
    price: {
      min: 300,
      max: 600
    },
    processingTime: '3-5 werkdagen',
    keyPoints: [
      'Opdracht',
      'Honorarium',
      'Aansprakelijkheid',
      'Intellectueel eigendom'
    ],
    useCases: [
      'Management advies',
      'Strategisch consult',
      'Interim management'
    ],
    relatedDocuments: [
      'Projectvoorstel',
      'Urenspecificatie',
      'Eindrapportage'
    ]
  },
  {
    id: '16',
    name: 'Algemene Voorwaarden Management / Consultancy (zzp) Engels',
    category: 'commercial',
    description: 'General terms and conditions for management and consultancy services.',
    price: {
      min: 350,
      max: 700
    },
    processingTime: '3-5 werkdagen',
    keyPoints: [
      'Assignment',
      'Fees',
      'Liability',
      'Intellectual property'
    ],
    useCases: [
      'Management advice',
      'Strategic consulting',
      'Interim management'
    ],
    relatedDocuments: [
      'Project proposal',
      'Time specification',
      'Final report'
    ]
  },
  {
    id: '17',
    name: 'Algemene Voorwaarden huurcontract overige bedrijfsruimte',
    category: 'commercial',
    description: 'Algemene voorwaarden voor huur van bedrijfsruimte.',
    price: {
      min: 150,
      max: 300
    },
    processingTime: '2-3 werkdagen',
    keyPoints: [
      'Huurvoorwaarden',
      'Onderhoud',
      'Gebruik',
      'Opzegging'
    ],
    useCases: [
      'Kantoorhuur',
      'Bedrijfsruimte',
      'Opslag'
    ],
    relatedDocuments: [
      'Huurovereenkomst',
      'Opleveringsrapport',
      'Huishoudelijk reglement'
    ]
  },
  {
    id: '18',
    name: 'Algemene Voorwaarden Online Platform',
    category: 'commercial',
    description: 'Algemene voorwaarden voor online platforms en marktplaatsen.',
    price: {
      min: 350,
      max: 700
    },
    processingTime: '3-5 werkdagen',
    keyPoints: [
      'Gebruiksvoorwaarden',
      'Aansprakelijkheid',
      'Privacy',
      'Intellectueel eigendom'
    ],
    useCases: [
      'Online marktplaats',
      'Platform diensten',
      'Community website'
    ],
    relatedDocuments: [
      'Privacybeleid',
      'Cookiebeleid',
      'Gebruikersovereenkomst'
    ]
  },
  {
    id: '19',
    name: 'Algemene Voorwaarden voor apps',
    category: 'commercial',
    description: 'Algemene voorwaarden voor mobiele applicaties.',
    price: {
      min: 300,
      max: 600
    },
    processingTime: '3-5 werkdagen',
    keyPoints: [
      'Gebruiksrecht',
      'Privacy',
      'Updates',
      'Aansprakelijkheid'
    ],
    useCases: [
      'Mobiele apps',
      'Software applicaties',
      'App stores'
    ],
    relatedDocuments: [
      'Privacybeleid',
      'Gebruikershandleiding',
      'Support voorwaarden'
    ]
  },
  {
    id: '20',
    name: 'Algemene Voorwaarden Webshop B2B',
    category: 'commercial',
    description: 'Algemene voorwaarden voor B2B webshops.',
    price: {
      min: 300,
      max: 600
    },
    processingTime: '3-5 werkdagen',
    keyPoints: [
      'Bestelprocedure',
      'Leveringsvoorwaarden',
      'Betaling',
      'Garantie'
    ],
    useCases: [
      'Groothandel',
      'Zakelijke leveranciers',
      'Industriële verkoop'
    ],
    relatedDocuments: [
      'Inkoopvoorwaarden',
      'Retourbeleid',
      'Prijslijst'
    ]
  },
  {
    id: '21',
    name: 'Algemene Voorwaarden Webshop B2C',
    category: 'commercial',
    description: 'Algemene voorwaarden voor B2C webshops.',
    price: {
      min: 250,
      max: 500
    },
    processingTime: '3-5 werkdagen',
    keyPoints: [
      'Consumentenrechten',
      'Herroepingsrecht',
      'Garantie',
      'Retourbeleid'
    ],
    useCases: [
      'Online retail',
      'Consumentenverkoop',
      'E-commerce'
    ],
    relatedDocuments: [
      'Privacyverklaring',
      'Retourformulier',
      'Garantiecertificaat'
    ]
  },
  {
    id: '22',
    name: 'Algemene Voorwaarden Webshop B2C Engels',
    category: 'commercial',
    description: 'General terms and conditions for B2C webshops.',
    price: {
      min: 300,
      max: 600
    },
    processingTime: '3-5 werkdagen',
    keyPoints: [
      'Consumer rights',
      'Right of withdrawal',
      'Warranty',
      'Return policy'
    ],
    useCases: [
      'Online retail',
      'Consumer sales',
      'E-commerce'
    ],
    relatedDocuments: [
      'Privacy policy',
      'Return form',
      'Warranty certificate'
    ]
  },
  {
    id: '23',
    name: 'Algemene Voorwaarden Webshop B2B Engels',
    category: 'commercial',
    description: 'General terms and conditions for B2B webshops.',
    price: {
      min: 350,
      max: 700
    },
    processingTime: '3-5 werkdagen',
    keyPoints: [
      'Order process',
      'Delivery terms',
      'Payment conditions',
      'Warranty'
    ],
    useCases: [
      'Wholesale',
      'Business suppliers',
      'Industrial sales'
    ],
    relatedDocuments: [
      'Purchase conditions',
      'Return policy',
      'Price list'
    ]
  },
  {
    id: '24',
    name: 'Bemiddelingsovereenkomst',
    category: 'commercial',
    description: 'Mediation agreement for services or dispute resolution.',
    price: {
      min: 300,
      max: 600
    },
    processingTime: '3-5 werkdagen',
    keyPoints: [
      'Mediation process',
      'Dispute resolution',
      'Party agreements'
    ],
    useCases: [
      'Business dispute resolution',
      'Mediation services'
    ],
    relatedDocuments: [
      'Confidentiality agreement',
      'Settlement agreement'
    ]
  },
  {
    id: '25',
    name: 'Bemiddelingsovereenkomst Engels',
    category: 'commercial',
    description: 'Mediation agreement in English for dispute resolution.',
    price: {
      min: 350,
      max: 700
    },
    processingTime: '3-5 werkdagen',
    keyPoints: [
      'Mediation process',
      'Dispute resolution',
      'Party agreements'
    ],
    useCases: [
      'International mediation',
      'Dispute resolution services'
    ],
    relatedDocuments: [
      'Confidentiality agreement',
      'Settlement agreement'
    ]
  },
  {
    id: '26',
    name: 'Brief verzoek tot uitstel belastingbetaling i.v.m. coronavirus',
    category: 'legal',
    description: 'Request letter for deferral of tax payments due to the coronavirus pandemic.',
    price: {
      min: 100,
      max: 200
    },
    processingTime: '1-2 werkdagen',
    keyPoints: [
      'Tax deferral request',
      'Coronavirus-related measures'
    ],
    useCases: [
      'Tax deferral for businesses',
      'Pandemic relief measures'
    ],
    relatedDocuments: [
      'Tax payment extension',
      'Government communication'
    ]
  },
  {
    id: '27',
    name: 'Brief verzoek tot verlaging salaris DGA',
    category: 'legal',
    description: 'Request letter for salary reduction for a director-major shareholder (DGA).',
    price: {
      min: 75,
      max: 150
    },
    processingTime: '1-2 werkdagen',
    keyPoints: [
      'Salary reduction',
      'DGA salary adjustments'
    ],
    useCases: [
      'Salary reduction for directors',
      'Business cost reduction strategies'
    ],
    relatedDocuments: [
      'Employment agreement',
      'Salary adjustment agreement'
    ]
  },
  {
    id: '28',
    name: 'Converteerbare Leningsovereenkomst',
    category: 'commercial',
    description: 'Convertible loan agreement for investment purposes.',
    price: {
      min: 250,
      max: 500
    },
    processingTime: '3-5 werkdagen',
    keyPoints: [
      'Convertible loan terms',
      'Investment conditions',
      'Equity conversion option'
    ],
    useCases: [
      'Startup investment',
      'Convertible loan agreements'
    ],
    relatedDocuments: [
      'Shareholder agreement',
      'Investment agreement'
    ]
  },
  {
    id: '29',
    name: 'Converteerbare Leningsovereenkomst Engels',
    category: 'commercial',
    description: 'Convertible loan agreement in English for investment purposes.',
    price: {
      min: 300,
      max: 600
    },
    processingTime: '3-5 werkdagen',
    keyPoints: [
      'Convertible loan terms',
      'Investment conditions',
      'Equity conversion option'
    ],
    useCases: [
      'International investment',
      'Convertible loan agreements'
    ],
    relatedDocuments: [
      'Shareholder agreement',
      'Investment agreement'
    ]
  },
  {
    id: '30',
    name: 'Cookiebeleid',
    category: 'compliance',
    description: 'Cookie policy for website compliance with privacy regulations.',
    price: {
      min: 100,
      max: 200
    },
    processingTime: '1-2 werkdagen',
    keyPoints: [
      'Cookie usage',
      'User consent',
      'Privacy regulations'
    ],
    useCases: [
      'Website compliance',
      'Cookie consent management'
    ],
    relatedDocuments: [
      'Privacy policy',
      'Terms and conditions'
    ]
  },
  {
    id: '31',
    name: 'Cookiebeleid Engels',
    category: 'compliance',
    description: 'Cookie policy in English for website compliance with privacy regulations.',
    price: {
      min: 150,
      max: 250
    },
    processingTime: '1-2 werkdagen',
    keyPoints: [
      'Cookie usage',
      'User consent',
      'Privacy regulations'
    ],
    useCases: [
      'International website compliance',
      'Cookie consent management'
    ],
    relatedDocuments: [
      'Privacy policy',
      'Terms and conditions'
    ]
  },
  {
    id: '32',
    name: 'Detacheringsovereenkomst',
    category: 'commercial',
    description: 'Secondment agreement for temporary staffing solutions.',
    price: {
      min: 350,
      max: 700
    },
    processingTime: '3-5 werkdagen',
    keyPoints: [
      'Temporary staffing',
      'Employee transfer terms',
      'Secondment process'
    ],
    useCases: [
      'Temporary workforce',
      'Employee secondment'
    ],
    relatedDocuments: [
      'Employment contract',
      'Service agreement'
    ]
  },
  {
    id: '33',
    name: 'Disclaimer voor websites',
    category: 'legal',
    description: 'Disclaimer for websites, outlining legal terms and responsibilities.',
    price: {
      min: 100,
      max: 200
    },
    processingTime: '1-2 werkdagen',
    keyPoints: [
      'Website liability',
      'User responsibilities',
      'Legal disclaimers'
    ],
    useCases: [
      'Website legal protection',
      'Online service disclaimers'
    ],
    relatedDocuments: [
      'Terms and conditions',
      'Privacy policy'
    ]
  },
  {
    id: '34',
    name: 'Disclaimer voor websites Engels',
    category: 'legal',
    description: 'Disclaimer for websites in English to limit liability and provide legal information.',
    price: {
      min: 150,
      max: 250
    },
    processingTime: '2-3 werkdagen',
    keyPoints: [
      'Liability limitation',
      'Website usage terms',
      'Legal notices'
    ],
    useCases: [
      'Website compliance',
      'Business websites'
    ],
    relatedDocuments: [
      'Terms and conditions',
      'Privacy policy'
    ]
  },
  {
    id: '35',
    name: 'Geheimhoudingsverklaring (NDA)',
    category: 'legal',
    description: 'Non-disclosure agreement (NDA) to protect confidential information during negotiations or collaborations.',
    price: {
      min: 150,
      max: 300
    },
    processingTime: '3-5 werkdagen',
    keyPoints: [
      'Confidentiality',
      'Information protection',
      'Non-disclosure obligations'
    ],
    useCases: [
      'Business negotiations',
      'Partnership agreements'
    ],
    relatedDocuments: [
      'Contract agreement',
      'Partnership agreement'
    ]
  },
  {
    id: '36',
    name: 'Geheimhoudingsverklaring Engels (NDA)',
    category: 'legal',
    description: 'Non-disclosure agreement (NDA) in English to protect confidential information during negotiations or collaborations.',
    price: {
      min: 200,
      max: 350
    },
    processingTime: '3-5 werkdagen',
    keyPoints: [
      'Confidentiality',
      'Information protection',
      'Non-disclosure obligations'
    ],
    useCases: [
      'Business negotiations',
      'Partnership agreements'
    ],
    relatedDocuments: [
      'Contract agreement',
      'Partnership agreement'
    ]
  },
  {
    id: '37',
    name: 'Huurovereenkomst (Kantoorruimte)',
    category: 'commercial',
    description: 'Lease agreement for renting office space or commercial property.',
    price: {
      min: 250,
      max: 500
    },
    processingTime: '5-7 werkdagen',
    keyPoints: [
      'Rental terms',
      'Property conditions',
      'Lease duration'
    ],
    useCases: [
      'Office rental',
      'Commercial property leasing'
    ],
    relatedDocuments: [
      'Property inspection report',
      'Rental payment schedule'
    ]
  },
  {
    id: '38',
    name: 'Huurovereenkomst Engels (Kantoorruimte)',
    category: 'commercial',
    description: 'Lease agreement in English for renting office space or commercial property.',
    price: {
      min: 300,
      max: 550
    },
    processingTime: '5-7 werkdagen',
    keyPoints: [
      'Rental terms',
      'Property conditions',
      'Lease duration'
    ],
    useCases: [
      'Office rental',
      'Commercial property leasing'
    ],
    relatedDocuments: [
      'Property inspection report',
      'Rental payment schedule'
    ]
  },
  {
    id: '39',
    name: 'Aandeelhoudersovereenkomst',
    category: 'commercial',
    description: 'Shareholder agreement for regulating relationships among company shareholders.',
    price: {
      min: 400,
      max: 800
    },
    processingTime: '7-10 werkdagen',
    keyPoints: [
      'Ownership structure',
      'Shareholder rights',
      'Conflict resolution'
    ],
    useCases: [
      'Business partnerships',
      'Company formation'
    ],
    relatedDocuments: [
      'Share issuance',
      'Investment agreement'
    ]
  },
  {
    id: '40',
    name: 'Aandeelhoudersovereenkomst Engels',
    category: 'commercial',
    description: 'Shareholder agreement in English for regulating relationships among company shareholders.',
    price: {
      min: 450,
      max: 900
    },
    processingTime: '7-10 werkdagen',
    keyPoints: [
      'Ownership structure',
      'Shareholder rights',
      'Conflict resolution'
    ],
    useCases: [
      'Business partnerships',
      'Company formation'
    ],
    relatedDocuments: [
      'Share issuance',
      'Investment agreement'
    ]
  },
  
  {
    id: '41',
    name: 'Verkoopovereenkomst',
    category: 'commercial',
    description: 'Sales agreement for selling products or services, including terms of sale, delivery, and payment.',
    price: {
      min: 200,
      max: 500
    },
    processingTime: '5-7 werkdagen',
    keyPoints: [
      'Payment terms',
      'Delivery conditions',
      'Warranties and returns'
    ],
    useCases: [
      'Product sales',
      'Service agreements'
    ],
    relatedDocuments: [
      'Invoice',
      'Delivery receipt'
    ]
  },
  {
    id: '42',
    name: 'Verkoopovereenkomst Engels',
    category: 'commercial',
    description: 'Sales agreement in English for selling products or services, including terms of sale, delivery, and payment.',
    price: {
      min: 250,
      max: 550
    },
    processingTime: '5-7 werkdagen',
    keyPoints: [
      'Payment terms',
      'Delivery conditions',
      'Warranties and returns'
    ],
    useCases: [
      'Product sales',
      'Service agreements'
    ],
    relatedDocuments: [
      'Invoice',
      'Delivery receipt'
    ]
  },
  {
    id: '43',
    name: 'Vastgoedovereenkomst',
    category: 'commercial',
    description: 'Real estate agreement for buying, selling, or leasing property.',
    price: {
      min: 500,
      max: 1000
    },
    processingTime: '7-10 werkdagen',
    keyPoints: [
      'Property details',
      'Transaction terms',
      'Payment conditions'
    ],
    useCases: [
      'Real estate transactions',
      'Property leasing'
    ],
    relatedDocuments: [
      'Property inspection',
      'Title deed'
    ]
  },
  {
    id: '44',
    name: 'Vastgoedovereenkomst Engels',
    category: 'commercial',
    description: 'Real estate agreement in English for buying, selling, or leasing property.',
    price: {
      min: 600,
      max: 1200
    },
    processingTime: '7-10 werkdagen',
    keyPoints: [
      'Property details',
      'Transaction terms',
      'Payment conditions'
    ],
    useCases: [
      'Real estate transactions',
      'Property leasing'
    ],
    relatedDocuments: [
      'Property inspection',
      'Title deed'
    ]
  },
  {
  "id": "45",
  "name": "Arbeidsovereenkomst",
  "category": "HR",
  "description": "Employment contract for hiring employees, outlining terms of employment, salary, and benefits.",
  "price": {
    "min": 300,
    "max": 600
  },
  "processingTime": "5-7 werkdagen",
  "keyPoints": [
    "Employment terms",
    "Salary and benefits",
    "Job responsibilities"
  ],
  "useCases": [
    "Employee hiring",
    "Workplace agreements"
  ],
  "relatedDocuments": [
    "Job description",
    "Salary agreement"
  ]
},
{
  "id": "46",
  "name": "Arbeidsovereenkomst Engels",
  "category": "HR",
  "description": "Employment contract in English for hiring employees, outlining terms of employment, salary, and benefits.",
  "price": {
    "min": 350,
    "max": 650
  },
  "processingTime": "5-7 werkdagen",
  "keyPoints": [
    "Employment terms",
    "Salary and benefits",
    "Job responsibilities"
  ],
  "useCases": [
    "Employee hiring",
    "Workplace agreements"
  ],
  "relatedDocuments": [
    "Job description",
    "Salary agreement"
  ]
},
{
  "id": "47",
  "name": "Freelance Overeenkomst",
  "category": "HR",
  "description": "Freelance agreement outlining the terms of services, payment conditions, and project details for freelancers.",
  "price": {
    "min": 250,
    "max": 500
  },
  "processingTime": "3-5 werkdagen",
  "keyPoints": [
    "Project scope",
    "Payment terms",
    "Freelancer obligations"
  ],
  "useCases": [
    "Freelancer hiring",
    "Contracting services"
  ],
  "relatedDocuments": [
    "Invoice",
    "Project timeline"
  ]
},
{
  "id": "48",
  "name": "Freelance Overeenkomst Engels",
  "category": "HR",
  "description": "Freelance agreement in English outlining the terms of services, payment conditions, and project details for freelancers.",
  "price": {
    "min": 300,
    "max": 550
  },
  "processingTime": "3-5 werkdagen",
  "keyPoints": [
    "Project scope",
    "Payment terms",
    "Freelancer obligations"
  ],
  "useCases": [
    "Freelancer hiring",
    "Contracting services"
  ],
  "relatedDocuments": [
    "Invoice",
    "Project timeline"
  ]
},
{
  "id": "49",
  "name": "Leveringsvoorwaarden",
  "category": "commercial",
  "description": "Terms of delivery agreement outlining the conditions for shipping, delivery, and related services.",
  "price": {
    "min": 150,
    "max": 350
  },
  "processingTime": "3-5 werkdagen",
  "keyPoints": [
    "Delivery methods",
    "Shipping costs",
    "Return policy"
  ],
  "useCases": [
    "Product sales",
    "Delivery terms"
  ],
  "relatedDocuments": [
    "Invoice",
    "Shipment tracking"
  ]
},
{
  "id": "50",
  "name": "Leveringsvoorwaarden Engels",
  "category": "commercial",
  "description": "Terms of delivery agreement in English outlining the conditions for shipping, delivery, and related services.",
  "price": {
    "min": 200,
    "max": 400
  },
  "processingTime": "3-5 werkdagen",
  "keyPoints": [
    "Delivery methods",
    "Shipping costs",
    "Return policy"
  ],
  "useCases": [
    "Product sales",
    "Delivery terms"
  ],
  "relatedDocuments": [
    "Invoice",
    "Shipment tracking"
  ]
},
{
  "id": "51",
  "name": "Vertrouwenspersoon Overeenkomst",
  "category": "HR",
  "description": "Agreement for the appointment of a trusted person within the organization to handle workplace issues.",
  "price": {
    "min": 200,
    "max": 400
  },
  "processingTime": "5-7 werkdagen",
  "keyPoints": [
    "Role of the trusted person",
    "Handling workplace concerns",
    "Confidentiality"
  ],
  "useCases": [
    "Internal communication",
    "Employee support"
  ],
  "relatedDocuments": [
    "Employee handbook",
    "Internal communication policy"
  ]
},
{
  "id": "52",
  "name": "Vertrouwenspersoon Overeenkomst Engels",
  "category": "HR",
  "description": "Agreement in English for the appointment of a trusted person within the organization to handle workplace issues.",
  "price": {
    "min": 250,
    "max": 450
  },
  "processingTime": "5-7 werkdagen",
  "keyPoints": [
    "Role of the trusted person",
    "Handling workplace concerns",
    "Confidentiality"
  ],
  "useCases": [
    "Internal communication",
    "Employee support"
  ],
  "relatedDocuments": [
    "Employee handbook",
    "Internal communication policy"
  ]
},
{
  "id": "53",
  "name": "Overeenkomst Intellectueel Eigendom",
  "category": "legal",
  "description": "Intellectual property agreement to define ownership rights of creations, inventions, or innovations.",
  "price": {
    "min": 350,
    "max": 650
  },
  "processingTime": "5-7 werkdagen",
  "keyPoints": [
    "Intellectual property rights",
    "Ownership and licensing",
    "Confidentiality clauses"
  ],
  "useCases": [
    "Product development",
    "Innovation agreements"
  ],
  "relatedDocuments": [
    "Patent registration",
    "Trademark registration"
  ]
},
{
  "id": "54",
  "name": "Overeenkomst Intellectueel Eigendom Engels",
  "category": "legal",
  "description": "Intellectual property agreement in English to define ownership rights of creations, inventions, or innovations.",
  "price": {
    "min": 400,
    "max": 700
  },
  "processingTime": "5-7 werkdagen",
  "keyPoints": [
    "Intellectual property rights",
    "Ownership and licensing",
    "Confidentiality clauses"
  ],
  "useCases": [
    "Product development",
    "Innovation agreements"
  ],
  "relatedDocuments": [
    "Patent registration",
    "Trademark registration"
  ]
},
  {
  "id": "55",
  "name": "Non-concurrentie Overeenkomst",
  "category": "legal",
  "description": "Non-competition agreement to prevent employees or contractors from working with competitors during or after their contract period.",
  "price": {
    "min": 300,
    "max": 600
  },
  "processingTime": "5-7 werkdagen",
  "keyPoints": [
    "Non-competition terms",
    "Employment duration",
    "Post-contract restrictions"
  ],
  "useCases": [
    "Employee contracts",
    "Freelance agreements"
  ],
  "relatedDocuments": [
    "Employment contract",
    "Confidentiality agreement"
  ]
},
{
  "id": "56",
  "name": "Non-concurrentie Overeenkomst Engels",
  "category": "legal",
  "description": "Non-competition agreement in English to prevent employees or contractors from working with competitors during or after their contract period.",
  "price": {
    "min": 350,
    "max": 650
  },
  "processingTime": "5-7 werkdagen",
  "keyPoints": [
    "Non-competition terms",
    "Employment duration",
    "Post-contract restrictions"
  ],
  "useCases": [
    "Employee contracts",
    "Freelance agreements"
  ],
  "relatedDocuments": [
    "Employment contract",
    "Confidentiality agreement"
  ]
},
{
  "id": "57",
  "name": "Aandeelhoudersovereenkomst",
  "category": "legal",
  "description": "Shareholder agreement outlining the rights, responsibilities, and obligations of shareholders in a company.",
  "price": {
    "min": 500,
    "max": 1000
  },
  "processingTime": "7-10 werkdagen",
  "keyPoints": [
    "Shareholder rights",
    "Ownership percentages",
    "Decision-making process"
  ],
  "useCases": [
    "Company formation",
    "Investment agreements"
  ],
  "relatedDocuments": [
    "Company articles of association",
    "Share issuance"
  ]
},
{
  "id": "58",
  "name": "Aandeelhoudersovereenkomst Engels",
  "category": "legal",
  "description": "Shareholder agreement in English outlining the rights, responsibilities, and obligations of shareholders in a company.",
  "price": {
    "min": 550,
    "max": 1100
  },
  "processingTime": "7-10 werkdagen",
  "keyPoints": [
    "Shareholder rights",
    "Ownership percentages",
    "Decision-making process"
  ],
  "useCases": [
    "Company formation",
    "Investment agreements"
  ],
  "relatedDocuments": [
    "Company articles of association",
    "Share issuance"
  ]
},
{
  "id": "59",
  "name": "Algemene Voorwaarden",
  "category": "legal",
  "description": "General terms and conditions document setting the general rules for business transactions, customer service, and refunds.",
  "price": {
    "min": 200,
    "max": 450
  },
  "processingTime": "5-7 werkdagen",
  "keyPoints": [
    "Business rules",
    "Customer obligations",
    "Refund policy"
  ],
  "useCases": [
    "Online stores",
    "Business transactions"
  ],
  "relatedDocuments": [
    "Privacy policy",
    "Shipping terms"
  ]
},
{
  "id": "60",
  "name": "Algemene Voorwaarden Engels",
  "category": "legal",
  "description": "General terms and conditions document in English setting the general rules for business transactions, customer service, and refunds.",
  "price": {
    "min": 250,
    "max": 500
  },
  "processingTime": "5-7 werkdagen",
  "keyPoints": [
    "Business rules",
    "Customer obligations",
    "Refund policy"
  ],
  "useCases": [
    "Online stores",
    "Business transactions"
  ],
  "relatedDocuments": [
    "Privacy policy",
    "Shipping terms"
  ]
},
{
  "id": "61",
  "name": "Webdesign Overeenkomst",
  "category": "commercial",
  "description": "Web design agreement specifying the scope of work, payment terms, and deadlines for web design projects.",
  "price": {
    "min": 400,
    "max": 800
  },
  "processingTime": "7-10 werkdagen",
  "keyPoints": [
    "Scope of work",
    "Design and development",
    "Payment milestones"
  ],
  "useCases": [
    "Website development",
    "Freelance web design"
  ],
  "relatedDocuments": [
    "Project brief",
    "Invoice"
  ]
},
{
  "id": "62",
  "name": "Webdesign Overeenkomst Engels",
  "category": "commercial",
  "description": "Web design agreement in English specifying the scope of work, payment terms, and deadlines for web design projects.",
  "price": {
    "min": 450,
    "max": 850
  },
  "processingTime": "7-10 werkdagen",
  "keyPoints": [
    "Scope of work",
    "Design and development",
    "Payment milestones"
  ],
  "useCases": [
    "Website development",
    "Freelance web design"
  ],
  "relatedDocuments": [
    "Project brief",
    "Invoice"
  ]
},
{
  "id": "63",
  "name": "Overeenkomst voor Softwareontwikkeling",
  "category": "legal",
  "description": "Software development agreement detailing the scope, responsibilities, and timelines for software projects.",
  "price": {
    "min": 600,
    "max": 1200
  },
  "processingTime": "10-14 werkdagen",
  "keyPoints": [
    "Development scope",
    "Timeline and milestones",
    "Intellectual property rights"
  ],
  "useCases": [
    "Software development",
    "Freelance developers"
  ],
  "relatedDocuments": [
    "Project plan",
    "Code ownership agreement"
  ]
},
{
  "id": "64",
  "name": "Overeenkomst voor Softwareontwikkeling Engels",
  "category": "legal",
  "description": "Software development agreement in English detailing the scope, responsibilities, and timelines for software projects.",
  "price": {
    "min": 650,
    "max": 1300
  },
  "processingTime": "10-14 werkdagen",
  "keyPoints": [
    "Development scope",
    "Timeline and milestones",
    "Intellectual property rights"
  ],
  "useCases": [
    "Software development",
    "Freelance developers"
  ],
  "relatedDocuments": [
    "Project plan",
    "Code ownership agreement"
  ]
},
{
  "id": "65",
  "name": "Dienstverleningsovereenkomst",
  "category": "commercial",
  "description": "Service agreement outlining the terms and conditions of providing services, including deliverables, timelines, and payment terms.",
  "price": {
    "min": 350,
    "max": 700
  },
  "processingTime": "7-10 werkdagen",
  "keyPoints": [
    "Service deliverables",
    "Payment terms",
    "Confidentiality clauses"
  ],
  "useCases": [
    "Freelance services",
    "Consulting agreements"
  ],
  "relatedDocuments": [
    "Invoice",
    "Scope of work"
  ]
},
{
  "id": "66",
  "name": "Dienstverleningsovereenkomst Engels",
  "category": "commercial",
  "description": "Service agreement in English outlining the terms and conditions of providing services, including deliverables, timelines, and payment terms.",
  "price": {
    "min": 400,
    "max": 750
  },
  "processingTime": "7-10 werkdagen",
  "keyPoints": [
    "Service deliverables",
    "Payment terms",
    "Confidentiality clauses"
  ],
  "useCases": [
    "Freelance services",
    "Consulting agreements"
  ],
  "relatedDocuments": [
    "Invoice",
    "Scope of work"
  ]
},
{
  "id": "67",
  "name": "Licentieovereenkomst",
  "category": "legal",
  "description": "Licensing agreement specifying the terms under which one party grants rights to another party to use certain intellectual property.",
  "price": {
    "min": 400,
    "max": 800
  },
  "processingTime": "10-14 werkdagen",
  "keyPoints": [
    "Licensing terms",
    "Royalties",
    "Intellectual property rights"
  ],
  "useCases": [
    "Software licensing",
    "Brand licensing"
  ],
  "relatedDocuments": [
    "Intellectual property agreement",
    "Revenue sharing agreement"
  ]
},
{
  "id": "68",
  "name": "Licentieovereenkomst Engels",
  "category": "legal",
  "description": "Licensing agreement in English specifying the terms under which one party grants rights to another party to use certain intellectual property.",
  "price": {
    "min": 450,
    "max": 850
  },
  "processingTime": "10-14 werkdagen",
  "keyPoints": [
    "Licensing terms",
    "Royalties",
    "Intellectual property rights"
  ],
  "useCases": [
    "Software licensing",
    "Brand licensing"
  ],
  "relatedDocuments": [
    "Intellectual property agreement",
    "Revenue sharing agreement"
  ]
},
{
  "id": "69",
  "name": "Confidentialiteitsverklaring",
  "category": "legal",
  "description": "Non-disclosure agreement (NDA) to protect sensitive business information from being shared with third parties.",
  "price": {
    "min": 200,
    "max": 400
  },
  "processingTime": "3-5 werkdagen",
  "keyPoints": [
    "Confidential information",
    "Non-disclosure terms",
    "Duration of confidentiality"
  ],
  "useCases": [
    "Business partnerships",
    "Freelance agreements"
  ],
  "relatedDocuments": [
    "Employment contract",
    "Partnership agreement"
  ]
},
{
  "id": "70",
  "name": "Confidentialiteitsverklaring Engels",
  "category": "legal",
  "description": "Non-disclosure agreement (NDA) in English to protect sensitive business information from being shared with third parties.",
  "price": {
    "min": 250,
    "max": 450
  },
  "processingTime": "3-5 werkdagen",
  "keyPoints": [
    "Confidential information",
    "Non-disclosure terms",
    "Duration of confidentiality"
  ],
  "useCases": [
    "Business partnerships",
    "Freelance agreements"
  ],
  "relatedDocuments": [
    "Employment contract",
    "Partnership agreement"
  ]
},
{
  "id": "71",
  "name": "Privacy Policy Overeenkomst",
  "category": "legal",
  "description": "Privacy policy agreement ensuring compliance with data protection regulations and detailing how personal data will be handled.",
  "price": {
    "min": 300,
    "max": 600
  },
  "processingTime": "5-7 werkdagen",
  "keyPoints": [
    "Data collection",
    "Data processing",
    "User rights"
  ],
  "useCases": [
    "E-commerce websites",
    "Mobile apps"
  ],
  "relatedDocuments": [
    "Terms of service",
    "Cookie policy"
  ]
},
{
  "id": "72",
  "name": "Privacy Policy Overeenkomst Engels",
  "category": "legal",
  "description": "Privacy policy agreement in English ensuring compliance with data protection regulations and detailing how personal data will be handled.",
  "price": {
    "min": 350,
    "max": 650
  },
  "processingTime": "5-7 werkdagen",
  "keyPoints": [
    "Data collection",
    "Data processing",
    "User rights"
  ],
  "useCases": [
    "E-commerce websites",
    "Mobile apps"
  ],
  "relatedDocuments": [
    "Terms of service",
    "Cookie policy"
  ]
},
{
  "id": "73",
  "name": "Freelance Overeenkomst",
  "category": "commercial",
  "description": "Freelance agreement outlining the terms of freelance work, including payment rates, timelines, and deliverables.",
  "price": {
    "min": 250,
    "max": 500
  },
  "processingTime": "5-7 werkdagen",
  "keyPoints": [
    "Payment rates",
    "Timeline and milestones",
    "Scope of work"
  ],
  "useCases": [
    "Freelance projects",
    "Contractor agreements"
  ],
  "relatedDocuments": [
    "Invoice",
    "Scope of work"
  ]
},
  {
  "id": "74",
  "name": "Freelance Overeenkomst Engels",
  "category": "commercial",
  "description": "Freelance agreement in English outlining the terms of freelance work, including payment rates, timelines, and deliverables.",
  "price": {
    "min": 300,
    "max": 550
  },
  "processingTime": "5-7 werkdagen",
  "keyPoints": [
    "Payment rates",
    "Timeline and milestones",
    "Scope of work"
  ],
  "useCases": [
    "Freelance projects",
    "Contractor agreements"
  ],
  "relatedDocuments": [
    "Invoice",
    "Scope of work"
  ]
},
{
  "id": "75",
  "name": "Salarisovereenkomst",
  "category": "legal",
  "description": "Employment contract specifying salary terms, job duties, and other employment conditions.",
  "price": {
    "min": 350,
    "max": 700
  },
  "processingTime": "7-10 werkdagen",
  "keyPoints": [
    "Salary terms",
    "Job responsibilities",
    "Employee benefits"
  ],
  "useCases": [
    "Employee contracts",
    "Permanent job offers"
  ],
  "relatedDocuments": [
    "Non-compete clause",
    "Confidentiality agreement"
  ]
},
{
  "id": "76",
  "name": "Salarisovereenkomst Engels",
  "category": "legal",
  "description": "Employment contract in English specifying salary terms, job duties, and other employment conditions.",
  "price": {
    "min": 400,
    "max": 750
  },
  "processingTime": "7-10 werkdagen",
  "keyPoints": [
    "Salary terms",
    "Job responsibilities",
    "Employee benefits"
  ],
  "useCases": [
    "Employee contracts",
    "Permanent job offers"
  ],
  "relatedDocuments": [
    "Non-compete clause",
    "Confidentiality agreement"
  ]
},
{
  "id": "77",
  "name": "Samenwerkingsovereenkomst",
  "category": "commercial",
  "description": "Partnership agreement outlining the terms of collaboration between two or more parties, including profit sharing, roles, and responsibilities.",
  "price": {
    "min": 400,
    "max": 800
  },
  "processingTime": "10-14 werkdagen",
  "keyPoints": [
    "Profit sharing",
    "Roles and responsibilities",
    "Term of partnership"
  ],
  "useCases": [
    "Business partnerships",
    "Joint ventures"
  ],
  "relatedDocuments": [
    "Operating agreement",
    "Revenue sharing agreement"
  ]
},
{
  "id": "78",
  "name": "Samenwerkingsovereenkomst Engels",
  "category": "commercial",
  "description": "Partnership agreement in English outlining the terms of collaboration between two or more parties, including profit sharing, roles, and responsibilities.",
  "price": {
    "min": 450,
    "max": 850
  },
  "processingTime": "10-14 werkdagen",
  "keyPoints": [
    "Profit sharing",
    "Roles and responsibilities",
    "Term of partnership"
  ],
  "useCases": [
    "Business partnerships",
    "Joint ventures"
  ],
  "relatedDocuments": [
    "Operating agreement",
    "Revenue sharing agreement"
  ]
},
{
  "id": "79",
  "name": "Agentuurovereenkomst",
  "category": "commercial",
  "description": "Agency agreement outlining the terms of an agency relationship, including commission structure, duties, and rights.",
  "price": {
    "min": 300,
    "max": 600
  },
  "processingTime": "7-10 werkdagen",
  "keyPoints": [
    "Commission structure",
    "Duties and obligations",
    "Exclusivity clauses"
  ],
  "useCases": [
    "Sales agency",
    "Representation contracts"
  ],
  "relatedDocuments": [
    "Performance agreement",
    "Non-compete agreement"
  ]
},
{
  "id": "80",
  "name": "Agentuurovereenkomst Engels",
  "category": "commercial",
  "description": "Agency agreement in English outlining the terms of an agency relationship, including commission structure, duties, and rights.",
  "price": {
    "min": 350,
    "max": 650
  },
  "processingTime": "7-10 werkdagen",
  "keyPoints": [
    "Commission structure",
    "Duties and obligations",
    "Exclusivity clauses"
  ],
  "useCases": [
    "Sales agency",
    "Representation contracts"
  ],
  "relatedDocuments": [
    "Performance agreement",
    "Non-compete agreement"
  ]
},
{
  "id": "81",
  "name": "Leveringsovereenkomst",
  "category": "commercial",
  "description": "Delivery agreement outlining terms for the supply of goods or services, including timelines, quantities, and delivery conditions.",
  "price": {
    "min": 300,
    "max": 600
  },
  "processingTime": "5-7 werkdagen",
  "keyPoints": [
    "Delivery terms",
    "Quantities and specifications",
    "Payment conditions"
  ],
  "useCases": [
    "Goods supply agreements",
    "Service delivery contracts"
  ],
  "relatedDocuments": [
    "Purchase order",
    "Invoice"
  ]
},
{
  "id": "82",
  "name": "Leveringsovereenkomst Engels",
  "category": "commercial",
  "description": "Delivery agreement in English outlining terms for the supply of goods or services, including timelines, quantities, and delivery conditions.",
  "price": {
    "min": 350,
    "max": 650
  },
  "processingTime": "5-7 werkdagen",
  "keyPoints": [
    "Delivery terms",
    "Quantities and specifications",
    "Payment conditions"
  ],
  "useCases": [
    "Goods supply agreements",
    "Service delivery contracts"
  ],
  "relatedDocuments": [
    "Purchase order",
    "Invoice"
  ]
},
{
  "id": "83",
  "name": "Overeenkomst van opdracht",
  "category": "commercial",
  "description": "Agreement specifying the terms of service or task-based work, including scope, payment, and deadlines.",
  "price": {
    "min": 200,
    "max": 500
  },
  "processingTime": "5-7 werkdagen",
  "keyPoints": [
    "Scope of work",
    "Payment terms",
    "Deadlines"
  ],
  "useCases": [
    "Freelance projects",
    "Consulting agreements"
  ],
  "relatedDocuments": [
    "Invoice",
    "Payment schedule"
  ]
},
{
  "id": "84",
  "name": "Overeenkomst van opdracht Engels",
  "category": "commercial",
  "description": "Agreement in English specifying the terms of service or task-based work, including scope, payment, and deadlines.",
  "price": {
    "min": 250,
    "max": 550
  },
  "processingTime": "5-7 werkdagen",
  "keyPoints": [
    "Scope of work",
    "Payment terms",
    "Deadlines"
  ],
  "useCases": [
    "Freelance projects",
    "Consulting agreements"
  ],
  "relatedDocuments": [
    "Invoice",
    "Payment schedule"
  ]
},
{
  "id": "85",
  "name": "Verkoopovereenkomst",
  "category": "commercial",
  "description": "Sales agreement outlining the terms of a transaction between a buyer and a seller, including payment terms and product details.",
  "price": {
    "min": 400,
    "max": 700
  },
  "processingTime": "7-10 werkdagen",
  "keyPoints": [
    "Payment terms",
    "Product details",
    "Delivery conditions"
  ],
  "useCases": [
    "Product sales",
    "Retail transactions"
  ],
  "relatedDocuments": [
    "Invoice",
    "Warranty agreement"
  ]
},
{
  "id": "86",
  "name": "Verkoopovereenkomst Engels",
  "category": "commercial",
  "description": "Sales agreement in English outlining the terms of a transaction between a buyer and a seller, including payment terms and product details.",
  "price": {
    "min": 450,
    "max": 750
  },
  "processingTime": "7-10 werkdagen",
  "keyPoints": [
    "Payment terms",
    "Product details",
    "Delivery conditions"
  ],
  "useCases": [
    "Product sales",
    "Retail transactions"
  ],
  "relatedDocuments": [
    "Invoice",
    "Warranty agreement"
  ]
},
{
  "id": "87",
  "name": "Licentieovereenkomst",
  "category": "commercial",
  "description": "Licensing agreement specifying the terms under which one party grants the right to use a product, service, or intellectual property.",
  "price": {
    "min": 400,
    "max": 800
  },
  "processingTime": "7-10 werkdagen",
  "keyPoints": [
    "Licensing terms",
    "Royalty structure",
    "Territory and exclusivity"
  ],
  "useCases": [
    "Software licensing",
    "Intellectual property agreements"
  ],
  "relatedDocuments": [
    "Non-disclosure agreement",
    "Performance agreement"
  ]
},
{
  "id": "88",
  "name": "Licentieovereenkomst Engels",
  "category": "commercial",
  "description": "Licensing agreement in English specifying the terms under which one party grants the right to use a product, service, or intellectual property.",
  "price": {
    "min": 450,
    "max": 850
  },
  "processingTime": "7-10 werkdagen",
  "keyPoints": [
    "Licensing terms",
    "Royalty structure",
    "Territory and exclusivity"
  ],
  "useCases": [
    "Software licensing",
    "Intellectual property agreements"
  ],
  "relatedDocuments": [
    "Non-disclosure agreement",
    "Performance agreement"
  ]
},
{
  "id": "89",
  "name": "Huurcontract",
  "category": "legal",
  "description": "Lease agreement outlining the terms and conditions for renting a property or commercial space.",
  "price": {
    "min": 300,
    "max": 600
  },
  "processingTime": "7-10 werkdagen",
  "keyPoints": [
    "Rent amount",
    "Lease duration",
    "Maintenance responsibilities"
  ],
  "useCases": [
    "Residential rentals",
    "Commercial space leasing"
  ],
  "relatedDocuments": [
    "Deposit receipt",
    "Inventory list"
  ]
},
{
  "id": "90",
  "name": "Huurcontract Engels",
  "category": "legal",
  "description": "Lease agreement in English outlining the terms and conditions for renting a property or commercial space.",
  "price": {
    "min": 350,
    "max": 650
  },
  "processingTime": "7-10 werkdagen",
  "keyPoints": [
    "Rent amount",
    "Lease duration",
    "Maintenance responsibilities"
  ],
  "useCases": [
    "Residential rentals",
    "Commercial space leasing"
  ],
  "relatedDocuments": [
    "Deposit receipt",
    "Inventory list"
  ]
},
{
  "id": "91",
  "name": "Arbeidsovereenkomst",
  "category": "commercial",
  "description": "Employment agreement outlining the terms of employment, including job description, compensation, and benefits.",
  "price": {
    "min": 500,
    "max": 1000
  },
  "processingTime": "7-10 werkdagen",
  "keyPoints": [
    "Job description",
    "Compensation and benefits",
    "Work schedule"
  ],
  "useCases": [
    "Hiring employees",
    "Freelance and contract work"
  ],
  "relatedDocuments": [
    "Payroll agreement",
    "Benefits package"
  ]
},
{
  "id": "92",
  "name": "Arbeidsovereenkomst Engels",
  "category": "commercial",
  "description": "Employment agreement in English outlining the terms of employment, including job description, compensation, and benefits.",
  "price": {
    "min": 550,
    "max": 1050
  },
  "processingTime": "7-10 werkdagen",
  "keyPoints": [
    "Job description",
    "Compensation and benefits",
    "Work schedule"
  ],
  "useCases": [
    "Hiring employees",
    "Freelance and contract work"
  ],
  "relatedDocuments": [
    "Payroll agreement",
    "Benefits package"
  ]
},
{
  "id": "93",
  "name": "Overeenkomst van samenwerking",
  "category": "commercial",
  "description": "Partnership agreement outlining the terms of collaboration between two or more parties, including shared responsibilities and revenue distribution.",
  "price": {
    "min": 600,
    "max": 1200
  },
  "processingTime": "7-10 werkdagen",
  "keyPoints": [
    "Partnership roles",
    "Revenue sharing",
    "Decision-making process"
  ],
  "useCases": [
    "Joint ventures",
    "Collaborative business models"
  ],
  "relatedDocuments": [
    "Revenue report",
    "Exit strategy"
  ]
},
{
  "id": "94",
  "name": "Overeenkomst van samenwerking Engels",
  "category": "commercial",
  "description": "Partnership agreement in English outlining the terms of collaboration between two or more parties, including shared responsibilities and revenue distribution.",
  "price": {
    "min": 650,
    "max": 1300
  },
  "processingTime": "7-10 werkdagen",
  "keyPoints": [
    "Partnership roles",
    "Revenue sharing",
    "Decision-making process"
  ],
  "useCases": [
    "Joint ventures",
    "Collaborative business models"
  ],
  "relatedDocuments": [
    "Revenue report",
    "Exit strategy"
  ]
},
{
  "id": "95",
  "name": "Confidentialiteitsverklaring",
  "category": "legal",
  "description": "Non-disclosure agreement (NDA) outlining the terms under which confidential information will be protected between two or more parties.",
  "price": {
    "min": 150,
    "max": 400
  },
  "processingTime": "3-5 werkdagen",
  "keyPoints": [
    "Confidential information",
    "Non-disclosure period",
    "Consequences of breach"
  ],
  "useCases": [
    "Business partnerships",
    "Employee contracts"
  ],
  "relatedDocuments": [
    "Confidentiality guidelines",
    "Employment agreement"
  ]
},
{
  "id": "96",
  "name": "Confidentialiteitsverklaring Engels",
  "category": "legal",
  "description": "Non-disclosure agreement (NDA) in English outlining the terms under which confidential information will be protected between two or more parties.",
  "price": {
    "min": 200,
    "max": 450
  },
  "processingTime": "3-5 werkdagen",
  "keyPoints": [
    "Confidential information",
    "Non-disclosure period",
    "Consequences of breach"
  ],
  "useCases": [
    "Business partnerships",
    "Employee contracts"
  ],
  "relatedDocuments": [
    "Confidentiality guidelines",
    "Employment agreement"
  ]
},
{
  "id": "97",
  "name": "Aandeelhoudersovereenkomst",
  "category": "commercial",
  "description": "Shareholders agreement outlining the rights, responsibilities, and obligations of the shareholders of a company, including dividend distribution and decision-making processes.",
  "price": {
    "min": 750,
    "max": 1500
  },
  "processingTime": "7-10 werkdagen",
  "keyPoints": [
    "Shareholder rights",
    "Dividend distribution",
    "Decision-making processes"
  ],
  "useCases": [
    "Corporate governance",
    "Business structuring"
  ],
  "relatedDocuments": [
    "Company bylaws",
    "Board resolutions"
  ]
},
{
  "id": "98",
  "name": "Aandeelhoudersovereenkomst Engels",
  "category": "commercial",
  "description": "Shareholders agreement in English outlining the rights, responsibilities, and obligations of the shareholders of a company, including dividend distribution and decision-making processes.",
  "price": {
    "min": 800,
    "max": 1600
  },
  "processingTime": "7-10 werkdagen",
  "keyPoints": [
    "Shareholder rights",
    "Dividend distribution",
    "Decision-making processes"
  ],
  "useCases": [
    "Corporate governance",
    "Business structuring"
  ],
  "relatedDocuments": [
    "Company bylaws",
    "Board resolutions"
  ]
},
{
  "id": "99",
  "name": "Overeenkomst van koop en verkoop",
  "category": "commercial",
  "description": "Sales agreement outlining the terms of sale, including the product description, price, payment terms, and delivery schedule.",
  "price": {
    "min": 400,
    "max": 800
  },
  "processingTime": "5-7 werkdagen",
  "keyPoints": [
    "Product description",
    "Price and payment terms",
    "Delivery schedule"
  ],
  "useCases": [
    "Sales transactions",
    "Commercial agreements"
  ],
  "relatedDocuments": [
    "Invoice",
    "Receipt"
  ]
},
{
  "id": "100",
  "name": "Overeenkomst van koop en verkoop Engels",
  "category": "commercial",
  "description": "Sales agreement in English outlining the terms of sale, including the product description, price, payment terms, and delivery schedule.",
  "price": {
    "min": 450,
    "max": 850
  },
  "processingTime": "5-7 werkdagen",
  "keyPoints": [
    "Product description",
    "Price and payment terms",
    "Delivery schedule"
  ],
  "useCases": [
    "Sales transactions",
    "Commercial agreements"
  ],
  "relatedDocuments": [
    "Invoice",
    "Receipt"
  ]
},
{
  "id": "101",
  "name": "Licentieovereenkomst",
  "category": "intellectual_property",
  "description": "License agreement outlining the terms under which one party grants the other the right to use intellectual property, such as patents, trademarks, or software.",
  "price": {
    "min": 700,
    "max": 1200
  },
  "processingTime": "7-10 werkdagen",
  "keyPoints": [
    "Intellectual property rights",
    "Usage terms",
    "Duration of the license"
  ],
  "useCases": [
    "Software licensing",
    "Patent licensing"
  ],
  "relatedDocuments": [
    "Intellectual property rights transfer agreement",
    "Royalty agreement"
  ]
},
{
  "id": "102",
  "name": "Licentieovereenkomst Engels",
  "category": "intellectual_property",
  "description": "License agreement in English outlining the terms under which one party grants the other the right to use intellectual property, such as patents, trademarks, or software.",
  "price": {
    "min": 750,
    "max": 1300
  },
  "processingTime": "7-10 werkdagen",
  "keyPoints": [
    "Intellectual property rights",
    "Usage terms",
    "Duration of the license"
  ],
  "useCases": [
    "Software licensing",
    "Patent licensing"
  ],
  "relatedDocuments": [
    "Intellectual property rights transfer agreement",
    "Royalty agreement"
  ]
},
{
  "id": "103",
  "name": "Verhuurcontract",
  "category": "commercial",
  "description": "Lease agreement outlining the terms of rental, including rent amount, lease duration, and responsibilities of both the landlord and tenant.",
  "price": {
    "min": 300,
    "max": 600
  },
  "processingTime": "5-7 werkdagen",
  "keyPoints": [
    "Rent amount",
    "Lease duration",
    "Landlord and tenant responsibilities"
  ],
  "useCases": [
    "Property rental",
    "Commercial leases"
  ],
  "relatedDocuments": [
    "Inventory list",
    "Deposit agreement"
  ]
},
{
  "id": "104",
  "name": "Verhuurcontract Engels",
  "category": "commercial",
  "description": "Lease agreement in English outlining the terms of rental, including rent amount, lease duration, and responsibilities of both the landlord and tenant.",
  "price": {
    "min": 350,
    "max": 650
  },
  "processingTime": "5-7 werkdagen",
  "keyPoints": [
    "Rent amount",
    "Lease duration",
    "Landlord and tenant responsibilities"
  ],
  "useCases": [
    "Property rental",
    "Commercial leases"
  ],
  "relatedDocuments": [
    "Inventory list",
    "Deposit agreement"
  ]
},
{
  "id": "105",
  "name": "Overeenkomst van distributie",
  "category": "commercial",
  "description": "Distribution agreement outlining the terms of distribution for goods or services, including geographical area, exclusivity, and pricing.",
  "price": {
    "min": 800,
    "max": 1500
  },
  "processingTime": "7-10 werkdagen",
  "keyPoints": [
    "Geographical area",
    "Exclusivity terms",
    "Pricing"
  ],
  "useCases": [
    "Product distribution",
    "Franchise agreements"
  ],
  "relatedDocuments": [
    "Supply agreement",
    "Trademark licensing agreement"
  ]
},
{
  "id": "106",
  "name": "Overeenkomst van distributie Engels",
  "category": "commercial",
  "description": "Distribution agreement in English outlining the terms of distribution for goods or services, including geographical area, exclusivity, and pricing.",
  "price": {
    "min": 850,
    "max": 1600
  },
  "processingTime": "7-10 werkdagen",
  "keyPoints": [
    "Geographical area",
    "Exclusivity terms",
    "Pricing"
  ],
  "useCases": [
    "Product distribution",
    "Franchise agreements"
  ],
  "relatedDocuments": [
    "Supply agreement",
    "Trademark licensing agreement"
  ]
}

];